import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../constants/Constants";

 const setCookie = (name, value, ) => {
    // const days = 1
    // const date = new Date();
    // date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    // const expires = `expires=${date.toUTCString()}`;
    // document.cookie = `${name}=${value};${expires};path=/`;

    sessionStorage.setItem(COOKIE_PARA_NAME_FOR_JOURNEY_ID, value);
  }


  export default setCookie